import { NewSwHeaderComponent } from './new-sw-header/new-sw-header';
import { NotAuthorizedComponent } from './not-authorized/not-authorized';
// components import
import { NewCorePoc } from './new-core-poc/new-core-poc';
import { ProductPhotoWrapperComponent } from './product-photo-wrapper/product-photo-wrapper';

export const components: any[] = [
  // components export
  NewCorePoc,
  NewSwHeaderComponent,
  NotAuthorizedComponent,
  ProductPhotoWrapperComponent,
];
